<template>
    <div v-if="isOpen" class="fixed inset-0 top-[-1rem] bg-black bg-opacity-50 flex items-center justify-center z-50 w-full h-full p-8">
      <div class="bg-white rounded-lg shadow-lg w-full max-w-md p-6 relative dark:bg-dark-box-bg dark:border dark:border-dark-border dark:text-dark-text max-h-[90vh] overflow-y-auto" ref="modal" :style="modalStyle">
        <!-- <h2 class="text-2xl font-bold mb-4 text-gray-800 dark:text-dark-text">Stwórz Stacje Kolejową</h2> -->
        <div 
          class="cursor-move mb-4 pb-2 border-b dark:border-dark-border"
          @mousedown="startDrag"
          @touchstart="startDrag"
        >
          <h2 class="text-2xl font-bold text-gray-800 dark:text-dark-text">Stwórz Stacje Kolejową</h2>
        </div>

        <button @click="closeModal" class="absolute top-2 right-2 text-gray-500 hover:text-gray-700 focus:outline-none dark:text-dark-text dark:hover:text-dark-border-hover">
          <span class="text-xl">&times;</span>
        </button>
        <form @submit.prevent="submitForm" class="space-y-4">
  
          <!-- Nazwa Stacji -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Nazwa stacji <span class="text-red-600">(*)</span>:</label>
            <input
                v-model="localStation.name"
                type="text"
                class="w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
                :class="{ 'border-red-500 dark:border-dark-status-unavailable': localErrors.name }"
                @input="validateField('name')"
            />
            <span v-if="localErrors.name" class="text-red-500 text-sm mt-1 dark:text-dark-status-unavailable">{{ localErrors.name }}</span>
          </div>

          <!-- Kod pocztowy -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Kod pocztowy <span class="text-red-600">(*)</span>:</label>
            <input
                v-model="localStation.postcode"
                type="text"
                class="w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
                :class="{ 'border-red-500 dark:border-dark-status-unavailable': localErrors.postcode }"
                @input="validateField('postcode')"
            />
            <span v-if="localErrors.postcode" class="text-red-500 text-sm mt-1 dark:text-dark-status-unavailable">{{ localErrors.postcode }}</span>
          </div>

          <!-- Województwo -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Województwo <span class="text-red-600">(*)</span>:</label>
            <input
                v-model="localStation.voivodeShip"
                type="text"
                class="w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
                :class="{ 'border-red-500 dark:border-dark-status-unavailable': localErrors.voivodeShip }"
                @input="validateField('voivodeShip')"
            />
            <span v-if="localErrors.voivodeShip" class="text-red-500 text-sm mt-1 dark:text-dark-status-unavailable">{{ localErrors.voivodeShip }}</span>
          </div>
  
          <!-- Kod główny stacji -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Kod główny stacji:</label>
            <input
                v-model="localStation.mainCode"
                type="text"
                class="w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
                :class="{ 'border-red-500 dark:border-dark-status-unavailable': localErrors.mainCode }"
                @input="validateField('mainCode')"
            />
            <!-- <span v-if="localErrors.lastName" class="text-red-500 text-sm mt-1 dark:text-dark-status-unavailable">{{ localErrors.mainCode }}</span> -->
          </div>

          <!-- Submit -->
          <div class="flex justify-end">
            <button 
              type="submit" 
              :disabled="isFormInvalid" 
              class="w-full bg-button-bg text-button-text py-2 rounded-md hover:bg-button-hover focus:outline-none focus:ring focus:ring-indigo-500 dark:bg-dark-button-bg dark:hover:bg-dark-button-hover"
              :class="{ 'opacity-50 cursor-not-allowed': isFormInvalid }"
            >
              Zapisz zmiany
            </button>
          </div>
  
        </form>
      </div>
    </div>
  </template>
  
  <style scoped>
  /* Pasek przewijania w trybie ciemnym */
  .dark .overflow-y-auto::-webkit-scrollbar {
    width: 8px; /* Szerokość paska przewijania */
  }
  
  .dark .overflow-y-auto::-webkit-scrollbar-thumb {
    background-color: #2c7a7a; /* Teal-700 */
    border-radius: 8px; /* Zaokrąglenie suwaka */
    border: 2px solid #1a5d5d; /* Ciemniejszy odcień teal dla krawędzi suwaka */
  }
  
  .dark .overflow-y-auto::-webkit-scrollbar-track {
    background-color: #333333; /* Ciemne tło dla śledzenia paska */
    border-radius: 8px; /* Zaokrąglenie tła paska */
  }
  
  /* Pasek przewijania w trybie jasnym */
  .overflow-y-auto::-webkit-scrollbar {
    width: 8px; /* Szerokość paska przewijania */
  }
  
  .overflow-y-auto::-webkit-scrollbar-thumb {
    background-color: #d1d5db; /* Jasnoszary kolor suwaka (szary) */
    border-radius: 8px; /* Zaokrąglenie suwaka */
    border: 2px solid #9ca3af; /* Ciemniejszy szary dla krawędzi suwaka */
  }
  
  .overflow-y-auto::-webkit-scrollbar-track {
    background-color: #f3f4f6; /* Jasnoszare tło dla śledzenia paska */
    border-radius: 8px; /* Zaokrąglenie tła paska */
  }

  .cursor-move {
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
  }

  .dragging {
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
  }
  </style>
  
  <script>
  export default {
    props: {
      isOpen: Boolean,
      errors: Object
    },
    data() {
      return {
        localStation: {
            name: '',
            postcode: '',
            voivodeShip: '',
            mainCode: '',
        },
        localErrors: {
            name: '',
            postcode: '',
            voivodeShip: '',
            mainCode: ''
        },
        isSubmitting: false,
        isDragging: false,
        dragOffset: { x: 0, y: 0 },
        modalPosition: { x: 0, y: 0 }
      };
    },
    computed: {
      hasErrors() {
        // Sprawdza, czy istnieją jakiekolwiek błędy walidacyjne
        return Object.values(this.localErrors).some(error => error !== '');
      },
      isFormComplete() {
        // Sprawdza, czy każde wymagane pole zostało wypełnione
        return this.localStation.name !== '' && this.localStation.postcode !== '' && this.localStation.voivodeShip !== '';
      },
      isFormInvalid() {
        // Formularz jest niepoprawny, jeśli istnieją błędy lub brakuje wypełnionych pól
        return this.hasErrors || !this.isFormComplete;
      },
      modalStyle() {
        return {
          transform: `translate(${this.modalPosition.x}px, ${this.modalPosition.y}px)`
        };
      }
    },
    methods: {
      validateField(field) {
        // Aktualizacja kluczy do walidacji zgodnie z danymi dyspozytora
        switch (field) {
          case 'name':
            this.localErrors.name = !this.localStation.name ? 'Nazwa stacji jest wymagane' : '';
            break;
          case 'postcode':
            this.localErrors.postcode = !this.localStation.postcode ? 'Kod pocztowy jest wymagany' : '';
            break;
          case 'voivodeShip':
            this.localErrors.voivodeShip = !this.localStation.voivodeShip ? 'Województwo jest wymagane' : '';
            break;
          case 'mainCode':
            this.localErrors.mainCode = !this.localStation.mainCode ? 'Kod główny jest wymagany' : '';
            break;
        }
      },
      closeModal() {
        this.$emit('close');
      },
      async submitForm() {
        if (this.isSubmitting) return;
  
        this.isSubmitting = true;
  
        // Walidacja wszystkich pól
        this.validateField('name');
        this.validateField('postcode');
        this.validateField('voivodeShip');
        //this.validateField('mainCode');
  
        if (!Object.values(this.localErrors).some(error => error !== '')) {
          this.$emit('submit', this.localStation);
        } else {
          console.log('Popraw błędy w formularzu przed wysłaniem.');
        }
  
        this.localStation = {
            name: '',
            postcode: '',
            voivodeShip: '',
            mainCode: '',
        };
        this.localErrors = {
            name: '',
            postcode: '',
            voivodeShip: '',
            mainCode: ''
        };

        this.isSubmitting = false;
      },
      startDrag(event) {
        this.isDragging = true;
        
        event.currentTarget.classList.add('dragging');

        const clientX = event.clientX || event.touches[0].clientX;
        const clientY = event.clientY || event.touches[0].clientY;
        
        this.dragOffset.x = clientX - this.modalPosition.x;
        this.dragOffset.y = clientY - this.modalPosition.y;
        
        // Dodajemy event listeners
        document.addEventListener('mousemove', this.onDrag);
        document.addEventListener('touchmove', this.onDrag, { passive: false });
        document.addEventListener('mouseup', this.stopDrag);
        document.addEventListener('touchend', this.stopDrag);
      },
      onDrag(event) {
        if (!this.isDragging) return;
        
        event.preventDefault();
        
        const clientX = event.clientX || event.touches[0].clientX;
        const clientY = event.clientY || event.touches[0].clientY;
        
        this.modalPosition.x = clientX - this.dragOffset.x;
        this.modalPosition.y = clientY - this.dragOffset.y;
      },
      stopDrag() {
        this.isDragging = false;
        
        const dragElement = document.querySelector('.cursor-move');
        if (dragElement) {
          dragElement.classList.remove('dragging');
        }

        // Usuwamy event listeners
        document.removeEventListener('mousemove', this.onDrag);
        document.removeEventListener('touchmove', this.onDrag);
        document.removeEventListener('mouseup', this.stopDrag);
        document.removeEventListener('touchend', this.stopDrag);
      },
      resetPosition() {
        this.modalPosition = { x: 0, y: 0 };
      },
    }
  };
  </script>
  